const apiUrl = process.env.REACT_APP_API_URL;

export const GetEscolesLoop = async (page: string): Promise<any[]> => {
    try {
        const response = await fetch(`${apiUrl}:8072/escoles/loop`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        if (!response.ok) {
            console.error('GetEscolesLoop error:', response.status);
            return [];
        }
        const jsonData = await response.json();
        return Array.isArray(jsonData) ? jsonData : [];
    } catch (error) {
        console.log('GetEscolesLoop fetch error:', error);
        return [];
    }
};
